import { render } from "./wfm-sidebar.vue?vue&type=template&id=6fb31f58"
import script from "./wfm-sidebar.vue?vue&type=script&lang=js"
export * from "./wfm-sidebar.vue?vue&type=script&lang=js"

import "./wfm-sidebar.vue?vue&type=style&index=0&id=6fb31f58&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__